<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3 text-left" style="margin-bottom: -50px;">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ _.startCase(currentProfile).replace("B 2 B", "B2B") }}
          </h3>
          <h6 class="text-small text-muted mb-4" :class="type === 'dark' ? 'text-white'  : ''">
            Selected: {{checkedItems.length}}
          </h6>
        </div>
        <div class="col-md-9 text-right">
          <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="serverType == 'ho' && accessRights.includes('I') && currentProfile != 'b_2_b_customers' && currentProfile != 'b2b_customers'" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
            </template>
          </base-dropdown>

          <div v-if="serverType == 'ho'">
            <div v-if="checkedItems.length == 0 && accessRights.includes('A')">
              <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add
                {{ _.startCase(_.singularize(currentProfile)).replace("B 2 B", "B2B") }}</base-button>
            </div>

            <div v-else-if="checkedItems.length > 0 && accessRights.includes('W') && !currentProfile.includes('b_2_b_customers')">
              <base-button v-if="this.$parent.filterStatus != 'A' && currentProfile.includes('customers')"
                class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status', 'A')">Activate
              </base-button>
              <base-button v-if="this.$parent.filterStatus != 'I' && currentProfile.includes('customers')"
                class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status', 'I')">Deactivate
              </base-button>
              <div class="ml-1"></div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br />

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
          @end="dragging = false">
          <div class="list-group-item draggable"
            :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
            v-for="(element, index) in availableFields" :key="element">
            <div class="row">
              <!-- This _.startCase() will convert any casing into Start Case -->
              <div class="col-md-6">
                {{ _.startCase(element) }}
              </div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </base-alert>
        <div>
          <a-radio-group v-model="exportSelection">
            <a-radio :style="radioStyle" :value="0">Export All</a-radio>
            <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
            <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
            <a-radio :style="radioStyle" :value="3">Export Filtered</a-radio>
          </a-radio-group>
        </div>
        <div
          style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'import_list'">
        <import-profile @closeDrawer="closeDrawer"></import-profile>
      </div>
    </a-drawer>

    <a-drawer v-if="currentProfile == 'customers'" title="" :width="1000" placement="right" @close="onClose"
      :visible="visible">
      <div>
        <customer-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"
          :viewMode="viewMode"></customer-form>
      </div>
    </a-drawer>

    <a-drawer v-else-if="currentProfile == 'b_2_b_customers'" title="" :width="1000" placement="right" @close="onClose"
      :visible="visible">
      <div>
        <b2b-customer-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey"
          :viewMode="viewMode"></b2b-customer-form>
      </div>
    </a-drawer>

    <!-- <a-drawer title="" :width="1000" placement="right" @close="onClose" :visible="visible"> -->
    <a-drawer v-else title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <div>
        <customer-type-form v-if="currentProfile == 'customer_types'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></customer-type-form>
        <customer-card-type-form v-if="currentProfile == 'customer_card_types'" @closeDrawer="closeDrawer"
          v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></customer-card-type-form>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <a-spin :spinning="spinner" tip="Checking...">
      <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
        no-data-template="Empty" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log"
        @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">
        <template slot="actions" slot-scope="props">
          <center>
            <div v-if="serverType == 'ho'" class="table-button-container">
              <button v-if="accessRights.includes('V')" id="view" class="btn btn-success btn-sm"

                @click.prevent="showDrawer(props.rowData.id)">View</button>
              <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm"

                @click.prevent="showDrawer(props.rowData.id)">Edit</button>
              <template v-if="currentProfile =='b_2_b_customers'">
                <a-popconfirm v-if="accessRights.includes('D')" title="You are about to delete this record?"
                  @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                  <a class="btn btn-danger btn-sm text-white">Delete</a>
                </a-popconfirm>
              </template>  

              <!-- bryan -->
              <template v-else>
                <button v-if="accessRights.includes('D')" @click.prevent="checkBindedItems(props.rowData.id)"  class="btn btn-danger btn-sm text-white">
                    Delete
                 </button>
              </template>
            </div>
            <div v-else class="table-button-container">
              <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"

                @click.prevent="showDrawer(props.rowData.id)">View</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
      </a-spin>
      <a-modal 
                :visible="showModal" 
                :title="bindedItems !== 0? 'Cannot delete attribute' : 'You are about to delete this record?'" 
                :okButtonProps="bindedItems !== 0 && { style: { display: 'none'} }"
                @ok="deleteAttribute(currentRowDataId)" 
                @cancel="closeModal"
                :closable="false"
                >
                <p v-if="bindedItems!== 0">
                  There are {{ bindedItems }} item/s currently using this attribute. <br>
                </p>
                <p v-else>
                  Would you like to continue ?
                </p>
      </a-modal>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent'  : ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import {
  mapState,
  mapActions
} from 'vuex'

import CustomerForm from '../Customer Profiles/CustomerForm.vue';
import B2bCustomerForm from '../Customer Profiles/B2bCustomerForm.vue';
import CustomerTypeForm from '../Customer Profiles/CustomerTypeForm.vue';
import CustomerCardTypeForm from '../Customer Profiles/CustomerCardTypeForm.vue';
import ImportProfile from '../ImportProfile';

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import draggable from "vuedraggable";

import { formatStatus,decrypt } from "../../utilities.js"

var component_x;

export default {
  name: 'profiles-table',
  props: {
    type: {
      type: String
    },
    title: String
  },
  components: {
    Vuetable,
    VuetablePagination,
    CustomerForm,
    CustomerTypeForm,
    CustomerCardTypeForm,
    ImportProfile,
    draggable,
    B2bCustomerForm
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType'])
  },
  data() {
    return {
      initLoad: 0,
      viewMode: false,
      accessRights: [],
      errors: [],
      filterStatus: "",
      exportSelection: 0,
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      apiURL: "",
      fields: [],
      sortOrder: [{
        field: "name",
        direction: "asc"
      }],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      draggableKey: 0,
      // bryan
      showModal:false,
      bindedItems: 0,
      spinner:false,
      currentRowDataId:null,
      // end
    }
  },
  async created() {
    this.apiURL = this.currentApiURL.replace("b_2_b", "b2b")
  },
  watch: {
    currentApiURL: function () {
      this.$refs.vuetable.resetData()
      this.apiURL = this.currentApiURL.replace("b_2_b", "b2b")
    },
    parameters: function () {
      this.apiURL = this.currentApiURL.replace("b_2_b", "b2b")
      this.apiURL = this.apiURL.replace("b_2_b", "b2b") + this.parameters
      this.$refs.vuetable.selectedTo = []
      this.checkedItems = []
    },
    currentProfile: function () {
      this.initializeTable()
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        this.checkedFields = ["id","code", "name", "status"]
        this.fields = ["__checkbox", "id", "code", { name: "name", callback: (value) => decrypt(value)}, { name: "status", callback: (value) => formatStatus(value)}, "__slot:actions"]
        this.reinitializeFields();
      }
    } 
  },
  methods: {
    ...mapActions(['updateProfileId']),
    closeDrawer() {
      this.onClose()
    },
    refreshPage() {
      this.onClose()
      this.$refs.vuetable.refresh()
      this.successMessage = "Successful Operation"
      this.errorMessage = null
    },
    showDrawer(id) {
      if (event.target.id == "view") {
        this.viewMode = true
      } else {
        this.viewMode = false
      }
      this.componentKey++
      this.updateProfileId(id)
      this.visible = true
    },
    async showActionDrawer(action) {
      if (action == "customize_list") {
        var response = await HTTPRequest.getRequest(
          this.endPoint + this.currentProfile.replace("b_2_b", "b2b") + "/get_viewable_fields",
          null
        );
        
        let unsortedFields = response["fields"];
        let sortedFields = this.checkedFields.slice();

        unsortedFields.forEach(fieldName => {
          if (!this.checkedFields.includes(fieldName))
            sortedFields.push(fieldName)
        });

        this.availableFields = sortedFields;

      }
      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.errors = [];
      this.drawerVisible = false
      this.visible = false
      this.componentKey++
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
      // insert object status in fields
      if (this.fields.includes(fieldName)) {
        var indexValue2 = this.fields.indexOf(fieldName);
        if (indexValue2 > -1) {
          this.fields.splice(indexValue2, 1);
        }
      }else{
        if(fieldName == 'status'){
          let status_exist = false;
          this.fields.forEach((field, index) => {
            if(typeof field === 'object'){
              status_exist = index;
            }
          })
          if (status_exist){
            this.fields.splice(status_exist, 1)
          }else{
            this.fields.pop()
            this.fields.push({ name: "status", callback: (value) => formatStatus(value)})
            this.fields.push("__slot:actions")
          }
        }else if(fieldName == 'name' || fieldName == 'first_name' || fieldName == 'middle_name' || fieldName == 'last_name' || fieldName == 'mobile' || fieldName == 'email' || fieldName == 'telephone' || fieldName == 'tin'){
          let name_exist = false;
          this.fields.forEach((field, index) => {
            if(typeof field === 'object'){
              name_exist = index;
            }
          })
          if (name_exist){
            this.fields.splice(name_exist, 1)
          }else{
            this.fields.pop()
            this.fields.push({ name: fieldName, callback: (value) => decrypt(value)})
            this.fields.push("__slot:actions")
          }
        }else{
          this.fields.pop()
          this.fields.push(fieldName)
          this.fields.push("__slot:actions")
        }
      }
      let localStoreName = this.currentProfile + "customerCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));
      this.$refs.vuetable.normalizeFields();
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = []
        // this.fields = ['__checkbox', '__slot:actions']
      } else {
        this.checkedFields = this.availableFields.slice()
        this.fields = ['__checkbox']
        this.fields = this.fields.concat(this.checkedFields)
        this.fields = this.fields.map((value) =>{
          if(value == 'status'){
            return  { name: "status", callback: (value) => formatStatus(value) }
          } else if(value == 'name' || value == 'first_name' || value == 'middle_name' || value == 'last_name' || value == 'mobile' || value == 'email' || value == 'telephone' || value == 'tin'){
            return  { name: value, callback: (value) => decrypt(value) }
          // }else if (value == 'customer_type'){
          //   return  { name: "customer_class_name"}
          // }else if (value == 'credit_limit'){
          //   return {
          //     name: 'credit_limit',
          //     callback: (value) => {
          //       let val = (value/1).toFixed(2).replace(',', '.')
          //       return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          //     }
          //   }
          // }else if (value == 'payment_term'){
          //   return  { name: "payment_term_name"}
          }else{
            return value
          }
        })
        this.fields.push("__slot:actions")
      }
      let localStoreName = this.currentProfile + "customerCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));
      this.reinitializeFields();
    },
    reinitializeFields() {
      this.$nextTick(() => {
        this.$refs.vuetable.normalizeFields();
      });
    },
    async massupdate(field_name, value) {
      var field_update = {}
      field_update[field_name] = value
      var payload = {
        ids: this.checkedItems,
        field_update: field_update
      }
      var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile.replace("b_2_b", "b2b") + "/mass_update", null,
        payload)
      if (response["message"] == "Ok") {
        this.successMessage = "Successful updating status to "+ ((field_update['status'] == 'A') ? 'Active.' : 'Inactive.');
        this.$refs.vuetable.refresh()
        this.checkedItems = []
        this.$refs.vuetable.selectedTo = []
      } else {
        this.errorMessage = "Failed updating status to "+ ((field_update['status'] == 'A') ? 'Active.' : 'Inactive.');
      }
    },
    async onPaginationData(paginationData) {
      // await axios({
      //     method: 'PUT',
      //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
      //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
      // })
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.")
          this.$router.push("/")
        }
      } else {
        if (error.response.data.error == "Session expired") {
          alert("Session is already expired. Please login again.")
          document.getElementById("logoutButton").click()
        } else if(error.response.data.error == "Invalid IP for Access Token"){
          alert("Invalid Access Token. Please login again.")
          document.getElementById("logoutButton").click()
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
        // bryan START
    async checkBindedItems(id) {
      this.spinner = true
      axios({
        method: "get",
        url: this.endPoint + this.currentProfile + "/check_binded_items?id=" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      }).then(function (resp) {
        component_x.spinner = false
        component_x.showModal = true
        // console.log(resp.data.length)
        component_x.bindedItems = resp.data.length
        component_x.currentRowDataId = id
      })
        .catch(function () {
          alert("Invalid Credentials");
          component_x.spinner = false
        });
    },
    deleteAttribute(id) {
      this.deleteRow(id)
      this.closeModal()
    },
    closeModal() {
      this.showModal = !this.showModal
    },
    // bryan END
    deleteRow(id) {
      axios({
        method: 'delete',
        url: this.endPoint + this.currentProfile.replace("b_2_b", "b2b") + '/' + id,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record"
          component_x.$refs.vuetable.refresh()
        })
        .catch(function () {
          alert("Invalid Credentials")
        });
    },
    download() { // Must update other Profile Tables download function to be aligned
      var payload = {}
      var additional_parameters = ""
      var baseUrl = this.currentApiURL.replace("b_2_b", "b2b") + "/download?file_type=csv"
      if (this.exportSelection == "0") {
        // All
        payload["type"] = "all"
      } else if (this.exportSelection == "1") {
        // Current Page
        var ids = this.$refs.vuetable.tableData.map(({ id }) => id)
        payload["type"] = "current_page";
        if (ids == 0) {
          this.errors.push('No Record(s)');
          return;
        } else {
          payload["ids"] = ids
        }

      } else if (this.exportSelection == "2") {
        // Selected
        payload["type"] = "selected"
        if (this.checkedItems == 0) {
          this.errors.push('No Selected Record(s)');
          return;
        } else {
          payload["ids"] = this.checkedItems
        }
      } else {
        // Filtered
        payload["type"] = "filtered"
        additional_parameters = this.parameters
      }

      var exportFields = this.fields
      var cbIndex = this.fields.indexOf("__checkbox");
      if (cbIndex > -1) exportFields.splice(cbIndex, 1)
      var actionIndex = this.fields.indexOf("__slot:actions");
      if (actionIndex > -1) exportFields.splice(actionIndex, 1)

      payload["fields"] = exportFields
      additional_parameters = additional_parameters.replace('?', '&');

      axios({
        url: baseUrl + additional_parameters,
        method: 'POST',
        responseType: 'blob', // important
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.currentProfile+'.csv');
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = null
        this.successMessage = "Download successful"
      });
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose()
        this.errorMessage = message["error"]
        this.successMessage = null
      }
    },
    removeMessage(type) {
      if (type == 'error')
        this.errorMessage = null
      else
        this.successMessage = null
    },
    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["id", "code", "name", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }
      let localStoreName = this.currentProfile.replace("b_2_b", "b2b") + "customerCheckedFields"
      localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

      // this.fields = JSON.parse(localStorage.customerCheckedFields);
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        }else if (column === "name" || column == 'first_name' || column == 'middle_name' || column == 'last_name' || column == 'mobile' || column == 'email' || column == 'telephone' || column == 'tin') {
          return {
            name: column,
            callback: (value) => decrypt(value)
          }
        // }else if (column == 'customer_type'){
        //     return  { name: "customer_class_name"}
        // }else if (column == 'payment_term'){
        //   return  { name: "payment_term_name"}
        // }else if (column == 'credit_limit'){
        //   return {
        //       name: 'credit_limit',
        //       callback: (value) => {
        //         let val = (value/1).toFixed(2).replace(',', '.')
        //         return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        //       }
        //     }
        } else return column
      })
      this.fields.push("__slot:actions");
      this.fields.unshift("__checkbox")

      this.reinitializeFields();
      this.onClose();
    },
    formatMyNumber(number, decimal) {
        if (typeof number === 'string') {
            number = number.replace(/,/g, '');
        }
        number = parseFloat(number);
        if (isNaN(number)) {
            return '0.00';
        }

        number = Math.abs(number).toFixed(decimal);
        let splitNum = number.split('.');
        splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return splitNum.join(".");
    },
    // decrypt(value){
    //   console.log(value)
    //   var crypto = require('crypto');
    //   var password = '1R1ppl3@BarterXI2025';
    //   var key = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex).substr(0,32);
    //   var iv = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex).substr(0,16);
    //   const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    //   // Decrypt the data
    //   var decrypted = decipher.update(value, 'base64', 'utf8');
    //   decrypted += decipher.final('utf8');
    //   return decrypted
    // }
  },
  beforeMount: async function () {
    const customerTableColumnsList = localStorage.getItem(this.currentProfile.replace("b_2_b", "b2b") + "customerCheckedFields")
    if (customerTableColumnsList != undefined && customerTableColumnsList != null && customerTableColumnsList != "[]") {
      this.checkedFields = JSON.parse(customerTableColumnsList)
      this.fields = this.checkedFields.map(column => {
        if (column === "status") {
          return {
            name: "status",
            callback: (value) => formatStatus(value)
          }
        // }else if (column == 'customer_type'){
        //     return  { name: "customer_class_name"}
        }else if (column == 'credit_limit'){
          return {
              name: 'credit_limit',
              callback: (value) => this.formatMyNumber(value,2)
            }
            
        // }else if (column == 'payment_term'){
        //   return  { name: "payment_term_name"}
        }else if (column === "name" || column == 'first_name' || column == 'middle_name' || column == 'last_name' || column == 'mobile' || column == 'email' || column == 'telephone' || column == 'tin'){
          return {
              name: column,
              callback: (value) => decrypt(value)
            }
            
        // }else if (column == 'payment_term'){
        //   return  { name: "payment_term_name"}
        } else return column
      })
      this.fields.push("__slot:actions")
      this.fields.unshift("__checkbox")
      this.initLoad++
    } else {
      this.checkedFields = ["id", "code", "name", "status"];
      this.fields = [
        "__checkbox",
        "id",
        "code",
        {
          name: "name",
          callback: (value) => decrypt(value)
        },
        {
          name: "status",
          callback: (value) => formatStatus(value)
        },
        "__slot:actions"
      ];
      localStorage.removeItem(this.currentProfile.replace("b_2_b", "b2b") + "customerCheckedFields")
    }
  },
  mounted: function () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights
    this.apiURL = this.currentApiURL.replace("b_2_b", "b2b")
    this.currentProfile = this.currentProfile.replace("b_2_b", "b2b")
    // this.decrypt()
  }
}
</script>

<style>
.draggable {
  cursor: grab
}
</style>
